export default "__VITE_ASSET__7lqGBEzU__"